module.exports = __webpack_public_path__ + "img/warning.a5974b1b.svg";